<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :definition="definition"
    :caption="caption"
    :disabled="disabled"
    :parent-identifiers="parentIdentifiers"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
    :permission-code="'Domain'"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './form-mixin';

const Labels = {
  Yes: 'common.yes',
  No: 'common.no'
};

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    parentIdentifiers: {
      type: Object,
      default: () => null
    },
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      columns: [
        { field: 'finishDescription', label: 'common.finish' },
        { field: 'finishTypeDescription', label: 'common.finishType' },
        { field: 'applicableYN', label: 'domain.productGroupFinishApplicable', formatter: this.formatApplicable }
      ]
    };
  },
  methods: {
    formatApplicable(row, column, cellValue) {
      return cellValue ? this.$t(Labels.Yes) : this.$t(Labels.No);
    },
    generateSummary(row) {
      const summary = `${row.finishTypeDescription} - ${row.finishDescription}`;
      return summary;
    }
  }
};
</script>

<style lang="scss" scoped></style>
